import metaIcon from '../assets/platforms/meta.svg';
import googleAdsIcon from '../assets/platforms/google-ads.svg';
import tiktokIcon from '../assets/platforms/tiktok.svg';
import tiktokShopIcon from '../assets/platforms/tiktok-shop.svg';
import pinterestIcon from '../assets/platforms/pinterest.svg';
import amazonAdsIcon from '../assets/platforms/amazon-ads.svg';
import amazonSellerIcon from '../assets/platforms/amazon-seller.svg';
import shopifyIcon from '../assets/platforms/shopify.svg';

export interface ReportPlatform {
  id: string;
  name: string;
  icon: string;
  /** Platform ID used by the integrations / OAuth connections API. */
  connectionPlatformId: string;
}

export const REPORT_PLATFORMS: readonly ReportPlatform[] = [
  { id: 'meta', name: 'Meta Ads', icon: metaIcon, connectionPlatformId: 'meta' },
  { id: 'google_ads', name: 'Google Ads', icon: googleAdsIcon, connectionPlatformId: 'google_ads' },
  { id: 'tiktok_ads', name: 'TikTok Business', icon: tiktokIcon, connectionPlatformId: 'tiktok_business' },
  { id: 'tiktok_shop', name: 'TikTok Shop', icon: tiktokShopIcon, connectionPlatformId: 'tiktok_shop' },
  { id: 'shopify', name: 'Shopify', icon: shopifyIcon, connectionPlatformId: 'shopify' },
  { id: 'amazon_ads', name: 'Amazon Ads', icon: amazonAdsIcon, connectionPlatformId: 'amazon_ads' },
  { id: 'amazon', name: 'Amazon Seller', icon: amazonSellerIcon, connectionPlatformId: 'amazon_seller' },
  { id: 'pinterest', name: 'Pinterest', icon: pinterestIcon, connectionPlatformId: 'pinterest' },
];

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- array is non-empty
const FIRST_PLATFORM: ReportPlatform = REPORT_PLATFORMS[0]!;

export function getPlatformById(id: string): ReportPlatform {
  return REPORT_PLATFORMS.find((p) => p.id === id) ?? FIRST_PLATFORM;
}

export function getPlatformIcon(id: string): string {
  return getPlatformById(id).icon;
}

export function getConnectionPlatformId(reportId: string): string {
  return REPORT_PLATFORMS.find((p) => p.id === reportId)?.connectionPlatformId ?? reportId;
}
